import { Header, Icon, Label, ListIcon, ListItem, Segment } from "semantic-ui-react";
import ServerImage from "./ServerImage";
import TempLocalImage from "./TempLocalImage";
import moment from "moment";
import { OrgUser } from "../../models/OrgUser";
import { getSitePhotoTypeColor } from "../../utils/sitePhoto";
import { SitePhotoType } from "../../models/SitePhotoType";

interface Props {
  url?: string | null;
  file?: File;
  createdBy?: OrgUser | null;
  dateCreated?: string | null;
  comments?: string | null;
  type?: SitePhotoType;
  affectedServiceName?: string | null;
  noPhotoReason?: string | null;
}

const photoViewer = ({
  url,
  file,
  createdBy,
  dateCreated,
  comments,
  type,
  affectedServiceName,
  noPhotoReason,
}: Props) => {
  return (
    <Segment basic>
      {url ? (
        <ServerImage rounded src={url} centered style={{ maxHeight: "700px" }} />
      ) : file ? (
        <TempLocalImage rounded file={file} centered style={{ maxHeight: "700px" }} />
      ) : (
        <Segment placeholder style={{ minHeight: "300px" }}>
          <Header icon>
            <Icon name="ban" size="massive" color="grey" />
          </Header>
        </Segment>
      )}

      <ListItem>
        <ListIcon name="info circle" />
        {type && (
          <Label color={getSitePhotoTypeColor(type.key)} style={{ padding: "3px", marginTop: "10px" }} horizontal>
            {type.name}
          </Label>
        )}
        {affectedServiceName && (
          <Label color="blue" style={{ padding: "3px", marginTop: "10px" }} horizontal>
            Affected Service: {affectedServiceName}
          </Label>
        )}
        {(dateCreated || createdBy) && (
          <Label style={{ padding: "3px", marginTop: "10px" }} horizontal>
            {dateCreated && moment.utc(dateCreated).local().format("L")}
            {createdBy && " by " + createdBy.user.displayName}
          </Label>
        )}
        {noPhotoReason ? `No Photo Reason: ${noPhotoReason}` : comments ? comments : "No comment added."}
      </ListItem>
    </Segment>
  );
};

export default photoViewer;
